/** Turn FastAPI `detail` (string, object, or validation array) into user-facing text. */
export function httpErrorMessage(error: unknown, fallback: string): string {
  const detail = (error as { error?: { detail?: unknown } })?.error?.detail;
  const parsed = parseDetail(detail);
  return parsed || fallback;
}

function parseDetail(detail: unknown): string {
  if (typeof detail === 'string' && detail.trim()) {
    return detail.trim();
  }
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === 'string') {
          return item;
        }
        if (item && typeof item === 'object' && 'msg' in item) {
          const loc = Array.isArray((item as { loc?: unknown }).loc)
            ? (item as { loc: unknown[] }).loc.filter((part) => part !== 'body').join(' ')
            : '';
          const msg = String((item as { msg: string }).msg);
          return loc ? `${loc}: ${msg}` : msg;
        }
        return '';
      })
      .filter(Boolean)
      .join(' ');
  }
  if (detail && typeof detail === 'object' && 'message' in detail) {
    return String((detail as { message: string }).message);
  }
  if (detail && typeof detail === 'object' && 'msg' in detail) {
    return String((detail as { msg: string }).msg);
  }
  return '';
}
